// extracted by mini-css-extract-plugin
var _1 = "NOjIwHeowx7GNE2eGrRr";
var _2 = "Kvsi4aIo3G0BZscekKKw";
var _3 = "RkhspXgGKa_85fRTA2x_";
export { _1 as "container", _2 as "description", _3 as "title" }
